<template>
  <v-container v-if="$can('browse', 'InventoryItem')">
    <v-row
      no-gutters
      align="center"
      class="mb-6"
    >
      <v-col>
        <div class="headline">
          Inventory
        </div>
      </v-col>
      <v-col
        v-if="$can('create', 'InventoryItem') && $router.currentRoute.name === 'inventoryItems'"
        class="shrink"
      >
        <v-btn
          color="primary"
          class="ma-0"
          @click="openInventoryItemEditDialog()"
        >
          <v-icon left>
            add
          </v-icon>
          Add New Item
        </v-btn>
      </v-col>
    </v-row>

    <router-view ref="childComponent" />
  </v-container>
</template>

<script>
  export default {
    name: 'InventoryIndex',
    methods: {
      openInventoryItemEditDialog() {
        this.$refs.childComponent.openInventoryItemEditDialog()
      }
    }
  }
</script>
